// ═══════════════════════════════════════════════════════════════════════════════
// Previous-pairing import modal — first dashboard visit (§0.50)
// ═══════════════════════════════════════════════════════════════════════════════

import { useLanguage } from '../../contexts/LanguageContext';
import { AppModal } from '../ui/AppModal';
import { ImportPreviousPairingContent } from './ImportPreviousPairingContent';

type ImportPreviousPairingModalProps = {
  open: boolean;
  busy: boolean;
  onLater: () => void;
  onImported: () => void;
};

export const ImportPreviousPairingModal = ({
  open,
  busy,
  onLater,
  onImported,
}: ImportPreviousPairingModalProps) => {
  const { t } = useLanguage();

  return (
    <AppModal
      open={open}
      onClose={onLater}
      closeDisabled={busy}
      hideCloseButton
      ariaLabel={t('pairing.import.title')}
      closeAriaLabel={t('common.cancel')}
      backdropZClass="z-[70]"
      panelMaxWidthClass="max-w-lg"
    >
      <ImportPreviousPairingContent
        embedded
        showLaterButton
        onLater={onLater}
        onImportSuccess={onImported}
      />
    </AppModal>
  );
};
